import { render, staticRenderFns } from "./SugestaoSelectModal.vue?vue&type=template&id=95b746d8&scoped=true"
import script from "./SugestaoSelectModal.vue?vue&type=script&lang=js"
export * from "./SugestaoSelectModal.vue?vue&type=script&lang=js"
import style0 from "./SugestaoSelectModal.vue?vue&type=style&index=0&id=95b746d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b746d8",
  null
  
)

export default component.exports